export default (sitemap: SitemapBuilder) =>
{
    sitemap.after('[[[System]]]', [
        {
            name: '[[[Usługi]]]',
            short: '[[[Usługi]]]',
            icon: 'server',
            namespace: 'Ideo.Core.Common.Application.Permissions.Saas',
            children: [
                {
                    name: '[[[Klienci]]]',
                    route: 'saas-tenants',
                    icon: 'users',
                    auth: { all: ['TenantsPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie klienta]]]',
                            route: 'saas-tenants-add',
                            auth: { all: ['TenantsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja klienta]]]',
                            route: 'saas-tenants-edit',
                            auth: { all: ['TenantsPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Bazy danych]]]',
                    route: 'saas-databases',
                    icon: 'database',
                    auth: { all: ['DatabasesPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie serwera]]]',
                            route: 'saas-databases-add',
                            auth: { all: ['DatabasesPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja serwera]]]',
                            route: 'saas-databases-edit',
                            auth: { all: ['DatabasesPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Serwery plików]]]',
                    route: 'saas-storages',
                    icon: 'hard-drive',
                    auth: { all: ['StoragesPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie serwera]]]',
                            route: 'saas-storages-add',
                            auth: { all: ['StoragesPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja serwera]]]',
                            route: 'saas-storages-edit',
                            auth: { all: ['StoragesPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                }
            ]
        }
    ]);
};
